export default __webpack_public_path__ + "static/media/193.8aa725c5.gif";